module.exports = __webpack_public_path__ + "img/2mirageB.ace7ad91.jpg";